
import HomeComponent from './components/HomeComponent.vue';

export default {
  components: { HomeComponent }
}
